# User experience guide

The following resources provide a visual walkthrough of a Job Posting flow, incorporating SEEK’s recommended best practices and technical details.
These serve as a User Experience guide as well as a high-level technical reference to assist you in understanding how elements of the SEEK API work together during job ad creation.
Each field in the example flow is detailed with links to the corresponding sections of this documentation and API schema for further reference.

The PDF file contains a pre-rendered version of the flow that doesn’t require dedicated software to view.

The Figma file contains a componentised example based on SEEK’s [Braid Design System] intended to assist design implementation.
The design has been informed by hirer research, experience with other integrations and SEEK’s own job posting flow.
It’s recommended to adapt the design of these components to align with your software’s specific needs.

import { UxFiles } from './assets/UxFiles';

<UxFiles />

[braid design system]: https://seek-oss.github.io/braid-design-system/

## Updating a job ad

The walkthrough concentrates primarily on the initial creation of a job ad.
However, the SEEK API also allows updating and closing existing job ads.

When incorporating edit flows into your software, there are additional factors to consider, including:

- Ad selection must be displayed again to retrieve an ad product relevant to the job ad being updated.
- Questionnaires cannot be updated once a job ad has been posted.

For further detail on handling edits within your integration, refer to our [Updating a job ad] section.

[Updating a job ad]: /use-cases/job-posting/managing-job-ads/updating-a-job-ad
